export let LogCat = {
  Login: {
    TokenRefresh: 'TokenRefresh',
    ExternalLogin: 'Login',
    CreatePatientAccount: 'CreatePatientAccount',
    ForgotPassword: 'ForgotPassword',
    VersionDetails: 'VersionDetails'
  },
  SelfScheduling: {
    SuggestionsCalendar: 'SelfSchedulingSuggestionsCalendar',
    General: 'SelfSchedulingGeneral',
    Proxy: 'SelfSchedulingProxy',
    Service: 'SelfSchedulingService'
  },
  WorklistLocking: {
    Proxy: 'WorklistLockingProxy',
    Lock: 'WorklistLockingLock',
    Unlock: 'WorklistLockingUnlock',
    Override: 'WorklistLockingLockOverride',
    Hold: 'WorklistLockingLockHold',
    Join: 'WorklistLockingLockJoin',
    Refresh: 'WorklistLockingLockRefresh',
    Error: 'WorklistLockingLockError'
  },
  Comm: {
    Proxies: 'proxies'
  },
  Utils: {
    Serialization: 'utils.serialization'
  },
  Asset: {
    Proxy: 'AssetProxy',
    Service: 'AssetService'
  },
  Intl: {
    GetDefaultLanguage: 'IntlGetDefaultLanguage'
  }
};
